import { FormikProps } from "formik";
import CustomInput from "../../../components/common/Inputs/CustomInput";
import CustomError from "../../../components/common/CustomError";
import { RoleInterface } from "../../../interfaces/roleInterface";
import Sections from "./Sections";

type RoleFormProps = {
  formik: FormikProps<RoleInterface>;
};

export const RoleForm = (props: RoleFormProps) => {
  const { formik } = props;

  const hasAnyPermission = Object.values(formik.values.permissions).some(
    (action) => Object.values(action).some(Boolean),
  );

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <CustomInput
          label="Role"
          error={
            formik.touched.name &&
            formik.errors.name &&
            Array.isArray(formik.errors.name)
              ? formik.errors.name.join(", ")
              : formik.errors.name
          }
          {...formik.getFieldProps("name")}
          onChange={(e) => {
            formik.handleChange(e);
          }}
        />
      </div>
      <Sections formik={formik} />
      {formik.submitCount !== 0 && !hasAnyPermission ? (
        <CustomError error="Selecciona almenos un permiso" />
      ) : null}
    </>
  );
};
